import { useEffect, useState } from "react";
import { api } from "../../../lib/api";

export const ShiftsTab = () => {
  const [shifts, setShifts] = useState([]);
  useEffect(() => { api.get("/shifts").then((r) => setShifts(r.data)); }, []);

  return (
    <div className="bg-white border border-stone-200 rounded-lg divide-y divide-stone-100 max-w-lg">
      {shifts.map((s) => (
        <div key={s.id} className="p-4 flex justify-between text-sm">
          <span className="font-semibold">{s.name}</span>
          <span className="tabular-nums text-stone-500">{s.start_time} – {s.end_time}</span>
        </div>
      ))}
    </div>
  );
};
